import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewBoardsActions from './review-boards.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewBoardsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewBoardsActions.ReviewBoardsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_BOARDS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewBoardsActions.ReviewBoardsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewBoardsActions.ReviewBoardsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewBoardsActions.ReviewBoardsDelete(data.id));
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new ReviewBoardsActions.ReviewBoardsRefreshByID(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewBoardsActions.ReviewBoardsRefresh());
          break;
      }
    });
  }
}
